<template>
</template>

<script>
import Vue from 'vue';

 export default {
    name: 'startup',
    components: {
    },
     data () {
      return {
      }
    },
    computed: {
      
    },
    updated () {
    },
    mounted() {

       if (Vue.$errorStartup)
       {
         this.$router.push({ path: 'Error' })
         return;
       }

       this.$store.dispatch('allCategories');
       this.$router.push({ path: Vue.$baseUrl })
    },
   
  }
</script>


// WEBPACK FOOTER //
// src/pages/Startup.vue